import { VariableWrapper } from '@app/hcs-frontend';
import { Criticality_00, Criticality_10, Criticality_20 } from '@app/dp-shared';
export const getDiseaseProfilePresetData = (variable) => {
    const uiVar = new VariableWrapper(variable);
    let toRet = {
        initials: '',
        criticality: Criticality_00,
        variableId: uiVar.dbVariable._id,
        referenceIds: [],
        chiefComplaintIds: [],
        label: uiVar.dbVariable.name.toLowerCase(),
        icd: [],
        tagIds: [],
        colorGroup: '',
        _variableIds: [],
        _valueIds: [],
        _tagIds: []
    };
    toRet = {
        ...toRet,
        ...diseaseProfileInitials[uiVar.dbVariable.name.toLowerCase()],
        ...diseaseProfileColors[uiVar.getSystemTag()?.label.toLowerCase() || ''],
        ...diseaseProfileCriticality[uiVar.dbVariable.name.toLowerCase()],
    };
    return toRet;
};
export const isLight = (color) => {
    // Variables for red, green, blue values
    let r, g, b;
    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {
        // If RGB --> store the red, green, blue values in separate variables
        color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
        r = color[1];
        g = color[2];
        b = color[3];
    }
    else {
        // If hex --> Convert it to RGB: http://gist.github.com/983661
        color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
        r = color >> 16;
        g = color >> 8 & 255;
        b = color & 255;
    }
    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    const hsp = Math.sqrt(0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b));
    // Using the HSP value, determine whether the color is light or dark
    if (hsp > 170)
        return true;
    return false;
};
export const diseaseProfileInitials = {
    'acute myocardial infarction': { initials: 'AMI' },
    'aortic dissection': { initials: 'AD' },
    'cardiac tamponade': { initials: 'CT' },
    'cocaine toxicity': { initials: 'CTX' },
    'takotsubo cardiomyopathy': { initials: 'TCM' },
    'pulmonary embolism': { initials: 'PE' },
    'tension pneumothorax': { initials: 'TP' },
    'esophageal obstruction': { initials: 'EO' },
    'esophageal rupture': { initials: 'ER' },
    'sepsis': { initials: 'SPS' },
    'acute coronary syndrome': { initials: 'ACS' },
    'acute decompensated heart failure': { initials: 'AHF' },
    'high altitude pulmonary edema': { initials: 'HAPE' },
    'endocarditis': { initials: 'EC' },
    'myocarditis': { initials: 'MC' },
    'hypertensive crisis': { initials: 'HC' },
    'valvular heart disease': { initials: 'VHD' },
    'aortic stenosis': { initials: 'AS' },
    'acute chest syndrome': { initials: 'CSD' },
    'asthma': { initials: 'AMI' },
    'chronic obstructive pulmonary disease': { initials: 'COP' },
    'hemothorax': { initials: 'HET' },
    'mediastinitis': { initials: 'MD' },
    'pneumothorax': { initials: 'PT' },
    'cholecystitis': { initials: 'CC' },
    'pancreatitis': { initials: 'PC' },
    'anemia': { initials: 'AN' },
    'covid 19': { initials: 'C19' },
    'illicit drug use': { initials: 'IDU' },
    'dilated cardiomyopathy': { initials: 'DCM' },
    'hypertrophic cardiomyopathy': { initials: 'HCM' },
    'restrictive cardiomyopathy': { initials: 'RCM' },
    'angina pectoris': { initials: 'AP' },
    'long covid': { initials: 'LC' },
    'mitral valve prolapse': { initials: 'MVP' },
    'pericarditis': { initials: 'PC' },
    'bronchitis': { initials: 'BR' },
    'community acquired pneumonia': { initials: 'CAP' },
    'pleuritis': { initials: 'PL' },
    'tracheitis': { initials: 'TR' },
    'lung tumor': { initials: 'LT' },
    'pleural effusion': { initials: 'PLE' },
    'pulmonary hypertension': { initials: 'PHT' },
    'cor pulmonale': { initials: 'CPU' },
    'esophagitis': { initials: 'EG' },
    'esophageal spasm': { initials: 'ES' },
    'biliary colic': { initials: 'BC' },
    'diaphragmatic hernia': { initials: 'DH' },
    'gastroesophageal reflux disease': { initials: 'GERD' },
    'peptic disorder': { initials: 'PD' },
    'costochondritis': { initials: 'CC' },
    'intercostal strain': { initials: 'IS' },
    'musculoskeletal pain': { initials: 'MSK' },
    'rib fracture': { initials: 'RF' },
    'spinal cord compression': { initials: 'SC' },
    'herpes zoster': { initials: 'HZ' },
    'post herpetic neuritis': { initials: 'PHN' },
    'anxiety': { initials: 'AX' },
    'panic disorder': { initials: 'PN' },
    'atrial fibrillation': { initials: 'AF' },
    'venous thromboembolic disease': { initials: 'VTE' },
};
export const diseaseProfileColors = {
    'cardiovascular system': { backgroundColor: { value: '#fe7371' }, color: { value: '#FFFFFF' } },
    'central nervous system': { backgroundColor: { value: '#FFFF7F' }, color: { value: '#707070' } },
    'congenital-genetic': { backgroundColor: { value: '#D9EAD3' }, color: { value: '#707070' } },
    'drugs and toxicity': { backgroundColor: { value: '#FD29F8' }, color: { value: '' } },
    'ear nose throat system': { backgroundColor: { value: '#6D9EEB' }, color: { value: '#FFFFFF' } },
    'endocrine system': { backgroundColor: { value: '#95FFAA' }, color: { value: '#049B30' } },
    'metabolic system': { backgroundColor: { value: '#95FFAA' }, color: { value: '#049B30' } },
    'gastrointestinal tract system': { backgroundColor: { value: '#90B87D' }, color: { value: '#000000' } },
    'genitourinary system': { backgroundColor: { value: '#F3C174' }, color: { value: '#875305' } },
    'hematologic system': { backgroundColor: { value: '#D699FF' }, color: { value: '#7F01D2' } },
    'hepatobiliary system': { backgroundColor: { value: '#C99F1E' }, color: { value: '#FFFFFF' } },
    'immune system': { backgroundColor: { value: '#F4CCCC' }, color: { value: '#000000' } },
    'infectious diseases': { backgroundColor: { value: '#C55E5E' }, color: { value: '#FDF6BF' } },
    'integumentary system': { backgroundColor: { value: '#CFD4D8' }, color: { value: '#000000' } },
    'musculoskeletal system': { backgroundColor: { value: '#C7925B' }, color: { value: '#000000' } },
    'ophtalmic system': { backgroundColor: { value: '#FFF2CC' }, color: { value: '#000000' } },
    'psychiatric': { backgroundColor: { value: '#CFE2F3' }, color: { value: '#007CBE' } },
    'respiratory system': { backgroundColor: { value: '#9595FB' }, color: { value: '#2C2CFE' } },
    'lymphatic system': { backgroundColor: { value: '#000000' }, color: { value: '#FFFFFF' } },
};
const diseaseProfileCriticality = {
    'acute myocardial infarction': { criticality: Criticality_20 },
    'acute coronary syndrome': { criticality: Criticality_20 },
    'aortic dissection': { criticality: Criticality_20 },
    'cardiac tamponade': { criticality: Criticality_20 },
    'takotsubo cardiomyopathy': { criticality: Criticality_20 },
    'acute decompendated heart failure': { criticality: Criticality_20 },
    'pulmonary embolism': { criticality: Criticality_20 },
    'tension pneumothorax': { criticality: Criticality_20 },
    'esophageal obstruction': { criticality: Criticality_20 },
    'esophageal rupture': { criticality: Criticality_20 },
    'sepsis': { criticality: Criticality_20 },
    'high altitude pulmonary edema': { criticality: Criticality_10 },
    'cocaine toxicity': { criticality: Criticality_10 },
    'endocarditis': { criticality: Criticality_10 },
    'myocarditis': { criticality: Criticality_10 },
    'hypertensive crisis': { criticality: Criticality_10 },
    'valvular heart disease': { criticality: Criticality_10 },
    'aortic stenosis': { criticality: Criticality_10 },
    'acute chest syndrome': { criticality: Criticality_10 },
    'asthma': { criticality: Criticality_10 },
    'chronic obstructive pulmonary disease': { criticality: Criticality_10 },
    'hemothorax': { criticality: Criticality_10 },
    'mediatinitis': { criticality: Criticality_10 },
    'pneumothorax': { criticality: Criticality_10 },
    'cholecystitis': { criticality: Criticality_10 },
    'pancreatitis': { criticality: Criticality_10 },
    'anemia': { criticality: Criticality_10 },
    'covid 19': { criticality: Criticality_10 },
    'illicit drug use': { criticality: Criticality_10 },
    'dilated cardiomyopathy': { criticality: Criticality_00 },
    'hypertrophic cardiomyopathy': { criticality: Criticality_00 },
    'restrictive cardiomyopathy': { criticality: Criticality_00 },
    'angina pectoris': { criticality: Criticality_00 },
    'long covid': { criticality: Criticality_00 },
    'mitral valve prolapse': { criticality: Criticality_00 },
    'pericarditis': { criticality: Criticality_00 },
    'bronchitis': { criticality: Criticality_00 },
    'community aquaired pneumonia': { criticality: Criticality_00 },
    'pleuritis': { criticality: Criticality_00 },
    'tracheitis': { criticality: Criticality_00 },
    'lung tumor': { criticality: Criticality_00 },
    'pleural effusion': { criticality: Criticality_00 },
    'pulmonary hypertension': { criticality: Criticality_00 },
    'cor pulmonale': { criticality: Criticality_00 },
    'esophagitis': { criticality: Criticality_00 },
    'esophageal spasm': { criticality: Criticality_00 },
    'biliary colic': { criticality: Criticality_00 },
    'diaphragmatic hernia': { criticality: Criticality_00 },
    'gastroesophageal reflux disease': { criticality: Criticality_00 },
    'peptic disorder': { criticality: Criticality_00 },
    'costochondritis': { criticality: Criticality_00 },
    'intercostal strain': { criticality: Criticality_00 },
    'musculoskeletal pain': { criticality: Criticality_00 },
    'rib fracture': { criticality: Criticality_00 },
    'spinal cord comression': { criticality: Criticality_00 },
    'herpes zoster': { criticality: Criticality_00 },
    'post herpetic neuritis': { criticality: Criticality_00 },
    'anxiety': { criticality: Criticality_00 },
    'panic disorder': { criticality: Criticality_00 },
};
//# sourceMappingURL=getDiseaseProfilePresetData.js.map